import { logout } from "lib/api";
import { getLocale } from "lib/apolloClient";
import { useEffect } from "react";

export const useOnChangeStore = (): void => {
  const locale = getLocale();
  useEffect(() => {
    let store = window.localStorage.getItem("store");
    const currentLocale = locale ?? "en-GB";
    if (!store) {
      window.localStorage.setItem("store", currentLocale);
      store = currentLocale;
    }

    if (store !== locale) {
      logout();
      window.localStorage.setItem("store", currentLocale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
};
